// extracted by mini-css-extract-plugin
export default {"vendorAndCurrency":"VendorAndCurrency_vendorAndCurrency__184dK","exchangeDisplay":"VendorAndCurrency_exchangeDisplay__uzkZ3"};